<template>
    <div class="row h-100 justify-content-center align-items-center bg-danger text-light" style="background-color: #2f519a;">
        <div class="col-11 col-sm-8" style="background-color: #2f519a;">
            <Annex v-for="annex of getEvaluation.annexes" :key="annex.id" :annex="annex" />
            <br>
            <button class="btn btn-primary btn-block" @click="resultPage">Resultados</button>
        </div>
    </div>
</template>

<script>
import Annex from "@/components/Annex";
import router from "../router";
import axios from "axios";
import { Decimal } from "decimal.js";
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(["getUser", "getEvaluation", "getAnswers", "getAnnexes"]),
    },
    methods: {
        resultPage() {
            let total_questions = new Decimal(
                this.getEvaluation.annexes.length
            );

            let total_answers = new Decimal(this.getAnnexes.length);

            if (!total_questions.eq(total_answers)) {
                alert(
                    "Es necesario contestar todas las preguntas para poder calcular los resultados"
                );
                return false;
            }

            axios
                .post("/api/agility/answer", {
                    user: this.getUser,
                    evaluation: this.getEvaluation,
                    answers: this.getAnswers,
                    annexes: this.getAnnexes,
                })
                .then(() => {
                    router.push({
                        name: "Result",
                    });
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
    },
    components: {
        Annex,
    },
};
</script>

<style>
</style>
